import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-50 border-t border-gray-200 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center">
          <p className="text-gray-600 mb-4">Copyright © {currentYear} drimcms</p>
          <div className="flex flex-wrap justify-center gap-6 text-sm">
            <Link to="/terms" className="text-gray-600 hover:text-blue-600 transition-colors">
              Услови за користење
            </Link>
            <Link to="/privacy" className="text-gray-600 hover:text-blue-600 transition-colors">
              Политика на приватност
            </Link>
            <Link to="/refund" className="text-gray-600 hover:text-blue-600 transition-colors">
              Политика на рефундирање
            </Link>
            <Link to="/shipping" className="text-gray-600 hover:text-blue-600 transition-colors">
              Политика на испорака
            </Link>
          </div>
          <p className="text-gray-500 text-sm mt-4">Built with ❤️</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;